export const SET_AVAILABLE_ZONE_ENUMS = "SET_AVAILABLE_ZONE_ENUMS";
export const SET_LANG = 'SET_LANG'
export const SET_CATEGORY_ENUMS = 'SET_CATEGORY_ENUMS'
export const SET_SUB_CATEGORY_ENUMS = 'SET_SUB_CATEGORY_ENUMS'
export const SET_COLOR_ENUMS = 'SET_COLOR_ENUMS'
export const SET_YEAR_ENUMS = 'SET_YEAR_ENUMS'
export const SET_BRAND_ENUMS = 'SET_BRAND_ENUMS'
export const SET_MODEL_ENUMS = 'SET_MODEL_ENUMS'
export const SET_GARAGE_ENUMS = 'SET_GARAGE_ENUMS'
export const SET_BRANCH_ENUMS = 'SET_BRANCH_ENUMS'
export const SET_PROVIDER_ENUMS = 'SET_PROVIDER_ENUMS'
export const SET_FEATURES_ENUMS = 'SET_FEATURES_ENUMS'
export const SET_LICENSE_TYPE_ENUMS = 'SET_LICENSE_TYPE_ENUMS'
export const SET_LANGUAGE_ENUMS = 'SET_LANGUAGE_ENUMS'
export const SET_NATIONALITY_ENUMS = 'SET_NATIONALITY_ENUMS'
export const SET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS = 'SET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS'
export const SET_DRIVER_LIST_ENUMS = 'SET_DRIVER_LIST_ENUMS'
export const SET_ADMINS_ENUMS = 'SET_ADMINS_ENUMS'
export const SET_ROLES_ENUMS = 'SET_ROLES_ENUMS'
export const SET_ACTIVE_ROLES_ENUMS = 'SET_ACTIVE_ROLES_ENUMS'
export const SET_SERVICE_TYPE_ENUMS = 'SET_SERVICE_TYPE_ENUMS'
export const SET_CLIENT_ENUMS = 'SET_CLIENT_ENUMS'
export const SET_CITY_ENUMS = 'SET_CITY_ENUMS'
export const SET_DAMAGE_LEVEL_ENUMS = 'SET_DAMAGE_LEVEL_ENUMS'
export const SET_DAMAGE_AREA_ENUMS = 'SET_DAMAGE_AREA_ENUMS'
export const SET_BODY_DAMAGE_AREA_ENUMS = 'SET_BODY_DAMAGE_AREA_ENUMS'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_CLIENT_INFO = 'SET_CLIENT_INFO'
export const SET_COMPANIES_ENUMS = 'SET_COMPANIES_ENUMS'
export const SET_INSURANCE_COMPANY_ENUMS = 'SET_INSURANCE_COMPANY_ENUMS'
export const SET_REGIONS_ENUMS = 'SET_REGIONS_ENUMS'
export const SET_PROVINCES_ENUMS = 'SET_PROVINCES_ENUMS'
export const SET_ZONE_ENUMS = 'SET_ZONE_ENUMS'
export const SET_POS_ENUMS = 'SET_POS_ENUMS'
export const SET_MOBILE_ENUMS = 'SET_MOBILE_ENUMS'
export const SET_SERVICES_ENUMS = 'SET_SERVICES_ENUMS'
export const SET_DRIVER_AVAILABILITY = 'SET_DRIVER_AVAILABILITY'
export const SET_VEHICLE_AVAILABILITY = 'SET_VEHICLE_AVAILABILITY'
export const SET_PROMO_CODE_ENUMS = 'SET_PROMO_CODE_ENUMS'
export const SET_LTA_LIST_ENUMS = 'SET_LTA_LIST_ENUMS'
export const SET_CLIENT_TYPE_ENUMS = 'SET_CLIENT_TYPE_ENUMS'
export const SET_ACCOUNT_ENUMS = 'SET_ACCOUNT_ENUMS'
export const SET_PROFORMA_INVOICE_ENUMS = 'SET_PROFORMA_INVOICE_ENUMS'
export const SET_JV_ENUMS = 'SET_JV_ENUMS'
export const SET_RESERVATION_LIST_ENUMS = 'SET_RESERVATION_LIST_ENUMS'
export const SET_REMOTE_FINANCE_ACCOUNT_ENUMS = 'SET_REMOTE_FINANCE_ACCOUNT_ENUMS'
export const SET_TAX_TYPE_ENUMS = 'SET_TAX_TYPE_ENUMS'
export const SET_TAX_TYPE_ZOHO_ENUMS = 'SET_TAX_TYPE_ZOHO_ENUMS'
export const SET_OPERATOR = 'SET_OPERATOR'
export const SET_TRAINING_TYPES_ENUMS = 'SET_TRAINING_TYPES_ENUMS'
export const SET_TAX_TYPE_ODOO_ENUMS = 'SET_TAX_TYPE_ODOO_ENUMS'
export const SET_ODOO_REMOTE_FINANCE_ACCOUNT_ENUMS = 'SET_ODOO_REMOTE_FINANCE_ACCOUNT_ENUMS'
export const SET_PRODUCT_ENUMS = 'SET_PRODUCT_ENUMS'
export const SET_PRICING_LISTS_ENUMS = 'SET_PRICING_LISTS_ENUMS'
export const SET_TGA_TYPES_ENUMS = 'SET_TGA_TYPES_ENUMS'
export const SET_RELIGION_ENUMS = 'SET_RELIGION_ENUMS'
export const SET_CLIENT_GRADE_ENUMS = 'SET_CLIENT_GRADE_ENUMS'
export const SET_RESERVATION_CATEGORY_ENUMS = 'SET_RESERVATION_CATEGORY_ENUMS'
export const SET_SERVICE_CATEGORY_ENUMS = 'SET_SERVICE_CATEGORY_ENUMS'
export const SET_CONTRACT_TYPE_ENUMS = 'SET_CONTRACT_TYPE_ENUMS'
export const SET_DRIVER_USERNAME_ENUMS = 'SET_DRIVER_USERNAME_ENUMS'
export const SET_CLIENT_USERNAME_ENUMS = 'SET_CLIENT_USERNAME_ENUMS'
export const SET_RESOURCE_REQUEST_USERNAME_ENUMS = 'SET_RESOURCE_REQUEST_USERNAME_ENUMS'
export const SET_USER_ENUMS = 'SET_USER_ENUMS'
export const SET_MISSING_REQUEST_PAYLOAD = 'SET_MISSING_REQUEST_PAYLOAD'
export const SET_VEHICLE_TYPE_ENUMS = 'SET_VEHICLE_TYPE_ENUMS'
export const SET_BLANKET_ORDER_ENUMS = 'SET_BLANKET_ORDER_ENUMS'
export const SET_KPI_REASON_ENUMS = 'SET_KPI_REASON_ENUMS'
export const SET_CLIENT_CITY_ENUMS = 'SET_CLIENT_CITY_ENUMS'
export const SET_CLIENT_COUNTRY_ENUMS = 'SET_CLIENT_COUNTRY_ENUMS'
export const SET_MODEL_INCLUDED_ENUMS = 'SET_MODEL_INCLUDED_ENUMS'
export const SET_TOASTER_POP = 'SET_TOASTER_POP'
export const SET_AVAILABLE_RESERVATION_LIST_ENUMS = 'SET_AVAILABLE_RESERVATION_LIST_ENUMS'
export const SET_CHANGE_PASSWORD_TOKEN = 'SET_CHANGE_PASSWORD_TOKEN'
export const SET_SHIFT_TYPE_ENUMS = 'SET_SHIFT_TYPE_ENUMS'
export const SET_DRIVER_EMPLOYEE_ID = 'SET_DRIVER_EMPLOYEE_ID'
export const SET_CONTRACT_ID_ENUMS = 'SET_CONTRACT_ID_ENUMS'
export const SET_CONTRACT_ID_CLIENT_ENUMS = 'SET_CONTRACT_ID_CLIENT_ENUMS'
export const SET_PAYMENT_TYPES = 'SET_PAYMENT_TYPES'
export const SET_CLIENT_CONTACT_PERSON_ENUMS = 'SET_CLIENT_CONTACT_PERSON_ENUMS'
export const SET_ENTITY_ENUMS = 'SET_ENTITY_ENUMS'
export const SET_USERNAME_ENUMS = 'SET_USERNAME_ENUMS'
export const SET_ADMIN_CONFIGURATION_ENUMS = 'SET_ADMIN_CONFIGURATION_ENUMS'
export const SET_DRIVER_EMP_ID_ENUMS = 'SET_DRIVER_EMP_ID_ENUMS'
export const SET_ROUTES_ENUMS = 'SET_ROUTES_ENUMS'
export const SET_WORKFLOW_ENUMS = 'SET_WORKFLOW_ENUMS'
export const SET_PROFORMA_INVOICE_NUMBER_ENUMS = 'SET_PROFORMA_INVOICE_NUMBER_ENUMS'
export const SET_USER_NAME_ENUMS = 'SET_USER_NAME_ENUMS'
export const SET_BLANKET_ORDER_ORDER_CODE_ENUMS = 'SET_BLANKET_ORDER_ORDER_CODE_ENUMS'
export const SET_SERVICE_POINT_ENUMS = 'SET_SERVICE_POINT_ENUMS'
export const SET_WATER_SOURCE_ENUMS = 'SET_WATER_SOURCE_ENUMS'
export const SET_BRANCH_GARAGE_ENUMS = 'SET_BRANCH_GARAGE_ENUMS'
export const SET_Certificates_of_Completion_ENUMS = 'SET_Certificates_of_Completion_ENUMS'
export const SET_TRIP_COMPLETE_NOTE_ENUMS = 'SET_TRIP_COMPLETE_NOTE_ENUMS'
export const SET_TRIP_RATING_ENUMS = 'SET_TRIP_RATING_ENUMS'
export const SET_DRIVER_RATINGS_ENUMS = 'SET_DRIVER_RATINGS_ENUMS'
export const SET_DRIVER_RATING_SUMMARY_ENUMS = 'SET_DRIVER_RATING_SUMMARY_ENUMS'
export const SET_Certificate_of_Completion_BY_ID = 'SET_Certificate_of_Completion_BY_ID'
export const SET_Certificate_Contract_Details_ENUMS = 'SET_Certificate_Contract_Details_ENUMS'
export const SET_Create_Certificate_Of_Completion_ENUMS =
  'SET_Create_Certificate_Of_Completion_ENUMS'
export const SET_Certificate_Of_Completion_PROFILE_ENUMS =
  'SET_Certificate_Of_Completion_PROFILE_ENUMS'
export const SET_Get_Contractors_Contracts = 'SET_Get_Contractors_Contracts'
export const SET_Get_Tank_ENUMS = 'SET_Get_Tank_ENUMS'
export const SET_Certificate_Logs = 'SET_Certificate_Logs'
export const SET_Tanker_Type = 'SET_Tanker_Type'
